import React from 'react';
import { StepCard } from '../../../api/cafAutomation';
import { Icon } from '../Icon';
import { chipLabel, emailsClient, isEnding } from './steps';

export const StepChips: React.FC<{ steps: StepCard[] | null }> = ({ steps }) => {
  if (!steps) return <span className="cur-muted cur-small">Made with the old editor</span>;
  return (
    <span className="cur-step-chips">
      {steps.map((card, index) => (
        // Cards have no identity of their own; their position is their identity here.
        <React.Fragment key={index}>
          {index > 0 && <span className="cur-step-arrow" aria-hidden="true">→</span>}
          <span className={`cur-step-chip${emailsClient(card) ? ' is-email' : ''}${isEnding(card) ? ' is-ending' : ''}`}>
            {emailsClient(card) && <Icon name="mail" size="xs" />}{chipLabel(card)}
          </span>
        </React.Fragment>
      ))}
    </span>
  );
};
